import { resolveConvorcherApiTarget } from './convorcherTargets'
import { loadConvorcherTarget } from './convorcherChatLink'

export const API_TARGET = resolveConvorcherApiTarget(import.meta.env)
export const IS_LOCAL = /localhost|127\.0\.0\.1/.test(API_TARGET)

const _params = typeof window !== 'undefined'
  ? new URLSearchParams(window.location.search)
  : new URLSearchParams()

// FORCE_SHOW: true when running local OR when ?debugserver=1 is in the URL.
// URL param alone does NOT change the proxy — only shows the indicator.
export const FORCE_SHOW = IS_LOCAL || _params.has('debugserver')

if (IS_LOCAL) {
  console.warn(
    '%c⚠ LOCAL DEV SERVER — ' + API_TARGET + ' — NOT remote staging',
    'background:#f80;color:#000;font-weight:bold;padding:4px 10px;font-size:13px'
  )
} else if (import.meta.env.DEV) {
  console.log('[server] remote:', API_TARGET)
} else {
  // A DEPLOYED build must not print API_TARGET: that constant is resolved at
  // BUILD time, and a deployed build sets no VITE_CONVORCHER_API_TARGET (the
  // image is environment-free by design), so it falls back to the staging
  // default and names staging even on production gass. The runtime answer
  // lives in nginx; ask for it. This is the only place the deployed app can
  // tell you which convorcher it is on — see convorcherChatLink.js.
  loadConvorcherTarget({ env: import.meta.env, dev: false }).then(target => {
    if (target) console.log('[server] convorcher:', target)
  })
}
